import React from 'react';
import {Stack} from "@mui/material";
import {buildItemSx} from "@view/navigate/sx";
import {INavigateItem} from "@view/navigate/types";
import NavigateIcon from "@view/navigate/icon/NavigateIcon";
import NavigateText from "@view/navigate/text/NavigateText";
import {useAccountStyle} from "@containers/accountStyle/hooks/useAccountStyle";

interface IProps {
    navigate: INavigateItem,
    active?: boolean,
}

const NavigateItemContent = ({navigate, active}: IProps) => {

    const {tokens} = useAccountStyle()

    return (
        <Stack
            justifyContent={'center'}
            direction={'column'}
            alignItems={'center'}
            gap={'4px'}
            className={[active && 'active', navigate.isNewFeatures && 'new'].filter(Boolean).join(' ')}
            sx={buildItemSx(tokens)}
        >
            <NavigateIcon icon={navigate.image}/>

            <NavigateText
                label={navigate.label}
                isNewFeatures={navigate.isNewFeatures}
                isOldFeatures={navigate.isOldFeatures}
            />
        </Stack>
    );
};

export default NavigateItemContent;
